// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.analytic_lps_sample_type_enum */
var AnalyticLpsSampleTypeEnum;
(function (AnalyticLpsSampleTypeEnum) {
    AnalyticLpsSampleTypeEnum["liquid"] = "liquid";
    AnalyticLpsSampleTypeEnum["solid"] = "solid";
})(AnalyticLpsSampleTypeEnum || (AnalyticLpsSampleTypeEnum = {}));
;
export default AnalyticLpsSampleTypeEnum;
/** Zod schema for analytic_lps_sample_type_enum */
export const analyticLpsSampleTypeEnum = z.nativeEnum(AnalyticLpsSampleTypeEnum);
//# sourceMappingURL=AnalyticLpsSampleTypeEnum.js.map